module.exports = __webpack_public_path__ + "static/media/datacamp_logo.e34c17e5.jfif";